import { render, staticRenderFns } from "./smjc.vue?vue&type=template&id=32057e5c&scoped=true"
import script from "./smjc.vue?vue&type=script&lang=js"
export * from "./smjc.vue?vue&type=script&lang=js"
import style0 from "./smjc.vue?vue&type=style&index=0&id=32057e5c&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32057e5c",
  null
  
)

export default component.exports